/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum MaterialPositionErrorCodeEnum {
    'INVALID_HU_NOT_FOUND_SUPPLYING_PACKING_PLANT' = '002',
    'INVALID_HU_NOT_FOUND_PARTNER' = '004',
    'DEFAULT' = '000'
}
